import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, Typography } from '@mui/material';
import { CloseIcon } from '@icons';
import { ReactComponent as BackIcon } from '@public/images/arrow_back.svg';
import { ChatMagnifierIcon } from '@core/chat/icons';
import { IHeader } from './interfaces';
import { useStyles } from './styles';

const Header = ({
  text = '',
  onClose,
  isBig = false,
  onBack,
  onFind,
}: IHeader) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  if (isMobileOnly) {
    return (
      <Box sx={classes.headerMobile}>
        <Box sx={{ ...classes.headerText, ...classes.headerTextMobile }}>
          {onBack ? (
            <IconButton sx={classes.buttonIconMobile} onClick={onBack}>
              <BackIcon />
            </IconButton>
          ) : null}
          <Typography sx={classes.textMobile(!!onBack)}>{text}</Typography>
        </Box>
        <Box sx={classes.rightActionsMobile}>
          {onFind && (
            <Box sx={classes.findMobile} onClick={onFind}>
              <ChatMagnifierIcon sx={classes.findIconMobile} />
              <Typography sx={classes.findTextMobile}>
                {translate('inputPlaceholders.sidebarFindMobile')}
              </Typography>
            </Box>
          )}
          <IconButton sx={classes.buttonIconMobile} onClick={onClose}>
            <CloseIcon
              sx={{ ...classes.closeIcon, ...classes.closeIconMobile }}
            />
          </IconButton>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={classes.header(isBig)}>
      <Box sx={classes.headerText}>
        <Typography sx={classes.text}>{text}</Typography>
      </Box>
      <Box sx={classes.actions(!onBack)}>
        {onBack ? (
          <IconButton sx={classes.buttonIcon} onClick={onBack}>
            <BackIcon />
          </IconButton>
        ) : null}
        <IconButton sx={classes.buttonIcon} onClick={onClose}>
          <CloseIcon sx={classes.closeIcon} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Header;
